/**
 * Controller: PartnersListCategoriesCreateModal
 */
angular.module('acme.view.application.partners.list.categories.createModal.controllers', [])
.controller('PartnersListCategoriesCreateModalController', [ '$scope', '$uibModalInstance', 'categoriesList', function ($scope, $uibModalInstance, categoriesList) {

    $scope.errors = [];

    $scope.model = {
      name: '',
      description: '',
      code: ''
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.trim = function(s) {
      return s.replace(/\s+/g, '').toLowerCase();
    };

    $scope.isUnique = function() {
      var i, ii,
        trimmed,
        trimmedCurrent = $scope.trim($scope.model.name),
        r = true;

      for (i=0,ii=categoriesList.length;i<ii;i++) {
        trimmed = $scope.trim(categoriesList[i].name);
        if (trimmedCurrent === trimmed) {
          r = false;
          break;
        }
      }

      return r;

    };

    $scope.done = function() {
      if ($scope.isUnique()) {
        if ($scope.model.name.replace(/\s+/g, '').length > 0) {
          $scope.success();
        }else{
          $scope.errors.push({ message: 'Please enter a valid name'});
        }
      }else{
        $scope.errors.push({ message: 'A price list named "' + $scope.model.name + '" already exists' });
      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close($scope.model);
    };

    $scope.init();

}]);